import React from 'react';
import { Router, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

import { history } from '../_helpers';
import { alertActions } from '../_actions';
import { PrivateRoute } from '../_components/PrivateRoute';
import { HomePage } from '../_pages/HomePage';
import { LoginPage } from '../_components/common/LoginPage';
import { ForgotPassword } from "../_components/common/ForgotPassword"
import HOC from '../_components/common/HOC'
//Org Admin Area
import OrgAdminArea from '../_pages/Organzation/OrgAdminArea/index'
import OrgTeam from '../_pages/Organzation/OrgAdminArea/OrgTeam'
import TeamMemberUpload from '../_pages/Organzation/OrgAdminArea/TeamMemberUpload'
import OrgTeamMembers from '../_pages/Organzation/OrgAdminArea/OurTeamMembers'
import PaUsersPermissions from '../_pages/Organzation/OrgAdminArea/PaUsersPermissions'
import PaUsers from '../_pages/Organzation/OrgAdminArea/PsUsers'
import MemberLevel from '../_pages/Organzation/OrgAdminArea/MemberLevel'
//end

// Super Admin Area
import SuperAdminArea from '../_pages/Organzation/SuperAdminArea/index'
import OrgDetails from '../_pages/Organzation/SuperAdminArea/OrgDetails'


//  Analyze
import Analyze from '../_pages/Organzation/Analyze/index'
import DashBoard from '../_pages/Organzation/Analyze/Category/DashBoard'
import Compatibility from '../_pages/Organzation/Analyze/Category/Compatibility'
import RoleFitment from '../_pages/Organzation/Analyze/Category/RoleFitment'
import Competence from '../_pages/Organzation/Analyze/Category/Competency'
import Collaboration from '../_pages/Organzation/Analyze/Category/Collaboration'
import FocusArea from '../_pages/Organzation/Analyze/Category/FocusArea'
import LAndD from '../_pages/Organzation/Analyze/Category/L&D'
// L&D sub
import LDOrientation from '../_pages/Organzation/Analyze/Category/L&D/L&DOrientation'
//end
import ReviewQuestion from '../_pages/Organzation/Analyze/Category/ReviewQuestions'
import SWOT from '../_pages/Organzation/Analyze/Category/SWOT'
import VirtualTeams from '../_pages/Organzation/Analyze/Category/VirtualTeams'
//Virtual Teams sub
import ManageTeams from '../_pages/Organzation/Analyze/Category/VirtualTeams/ManageTeams'
import ShareTeam from '../_pages/Organzation/Analyze/Category/VirtualTeams/ShareTeam'
import TeamMembers from '../_pages/Organzation/Analyze/Category/VirtualTeams/TeamMembers'
//end

//Super Admin area
import SwotParameters from '../_pages/Organzation/Analyze/Category/SWOT/SwotParameters';
import Comparison from '../_pages/Organzation/Analyze/Category/Comparison';
import AddOrganisation from '../_pages/Organzation/SuperAdminArea/AddOrganisation';
import ManageBatch from '../_pages/Organzation/SuperAdminArea/ManageBatch';
import ManageOrgAdmins from '../_pages/Organzation/SuperAdminArea/ManageOrgAdmins';
import ManageCredits from '../_pages/Organzation/SuperAdminArea/ManageCredits';
import UpdateLatestAssessment from '../_pages/Organzation/SuperAdminArea/UpdateLatestAssessment';
import DefineMetrics from '../_pages/Organzation/SuperAdminArea/DefineMetrics';
import AssignMetricsToOrg from '../_pages/Organzation/SuperAdminArea/AssignMetricsToOrg';
import AssignRespondentsToOrg from '../_pages/Organzation/SuperAdminArea/AssignRespondentToOrg';
import SwotText from '../_pages/Organzation/SuperAdminArea/SwotText';
import FocusAreaText from '../_pages/Organzation/SuperAdminArea/FocusAreaText';
import ReviewQuestionsThreatOrWeekness from '../_pages/Organzation/SuperAdminArea/ReviewQuestionsThreatOrWeekness';
import ReviewQuestionsContext from '../_pages/Organzation/SuperAdminArea/ReviewQuestionsContext';
import { SetPassword } from '../_components/common/SetPassword';
import AttritionPredictor from '../_pages/Organzation/Analyze/Category/AttritionPredictor';
import HiringProbability from '../_pages/Organzation/Analyze/Category/HiringProbability';
import ModulePermissions from '../_pages/Organzation/OrgAdminArea/ModulePermissions';


class App extends React.Component {
    constructor(props) {
        super(props);

        const { dispatch } = this.props;
        // history.listen((location, action) => {
        //     // clear alert on location change
        //     dispatch(alertActions.clear());
        // });
    }


    render() {
        const { alert,state } = this.props;
        return (
            <Router history={history}>
                <div>
                    <PrivateRoute exact path="/" component={HomePage} />
                    {/* Org Admin Area */}
                    {/* Root */}
                    <PrivateRoute exact path="/organisation/:id/org-admin" component={OrgAdminArea} />
                    {/* End */}
                    <PrivateRoute exact path="/organisation/:id/org-admin/OrgTeam" component={OrgTeam} />
                    <PrivateRoute exact path="/organisation/:id/org-admin/TeamMemberUpload" component={TeamMemberUpload} />
                    <PrivateRoute exact path="/organisation/:id/org-admin/OrgTeamMembers" component={OrgTeamMembers} />
                    {/* <PrivateRoute exact path="/organisation/:id/org-admin/OrgTeamMembers/:teamId" component={OrgTeamMembers} /> */}
                    <PrivateRoute exact path="/organisation/:id/org-admin/PaUsersPermissions" component={PaUsersPermissions} />
                    <PrivateRoute exact path="/organisation/:id/org-admin/PaUsersPermissions/:id1" component={PaUsersPermissions} />
                    <PrivateRoute exact path="/organisation/:id/org-admin/ModulePermissions" component={ModulePermissions} />
                    <PrivateRoute exact path="/organisation/:id/org-admin/PaUsers" component={PaUsers} />
                    <PrivateRoute exact path="/organisation/:id/org-admin/MemberLevel" component={MemberLevel} />
                    {/* Org Admin Area End */}
                    {/* Super Admin Area */}
                    {/* Root */}
                    <PrivateRoute exact path="/organisation/:id/super-admin" component={SuperAdminArea} />
                    <PrivateRoute exact path="/organisation/:id/super-admin/org-details" component={OrgDetails} />
                    <PrivateRoute exact path="/organisation/:id/super-admin/add-organisation" component={AddOrganisation} />
                    <PrivateRoute exact path="/organisation/:id/super-admin/manage-batch" component={ManageBatch} />
                    <PrivateRoute exact path="/organisation/:id/super-admin/manage-org-admins" component={ManageOrgAdmins} />
                    <PrivateRoute exact path="/organisation/:id/super-admin/manage-credits" component={ManageCredits} />
                    <PrivateRoute exact path="/organisation/:id/super-admin/update-latest-assessment" component={UpdateLatestAssessment} />
                    <PrivateRoute exact path="/organisation/:id/super-admin/metric" component={DefineMetrics} />
                    <PrivateRoute exact path="/organisation/:id/super-admin/assign-metrics" component={AssignMetricsToOrg} />
                    <PrivateRoute exact path="/organisation/:id/super-admin/assign-assessors" component={AssignRespondentsToOrg} />
                    <PrivateRoute exact path="/organisation/:id/super-admin/analyse-text-swot" component={SwotText} />
                    <PrivateRoute exact path="/organisation/:id/super-admin/analyse-text-focus-areas" component={FocusAreaText} />
                    <PrivateRoute exact path="/organisation/:id/super-admin/orientation-text-review-questions-context" component={ReviewQuestionsContext} />
                    <PrivateRoute exact path="/organisation/:id/super-admin/analyse-text-review-threat" component={ReviewQuestionsThreatOrWeekness} />
                    <PrivateRoute exact path="/organisation/:id/super-admin/analyse-text-review-weakness" component={ReviewQuestionsThreatOrWeekness} />
                    {/* End */}
                    {/* Super Admin Area End*/}


                    {/* Analyze */}
                    {/* Root */}
                    <PrivateRoute exact path="/organisation/:id/user" component={Analyze} history={history}/>
                    {/* end */}
                    <PrivateRoute exact path="/organisation/:id/user/dashboard" component={DashBoard} history={history}/>
                    <PrivateRoute exact path="/organisation/:id/user/swot" component={SWOT} history={history}/>
                    <PrivateRoute exact path="/organisation/:id/user/focus-area" component={FocusArea} history={history}/>
                    <PrivateRoute exact path="/organisation/:id/user/review-questions" component={ReviewQuestion} history={history}/>
                    <PrivateRoute exact path="/organisation/:id/user/collaboration" component={Collaboration} history={history}/>
                    {/* <PrivateRoute exact path="/organisation/:id/user/collaboration/:teamId" component={Collaboration} history={history}/> */}
                    {/* <PrivateRoute exact path="/organisation/:id/user/comparison" component={Comparison} history={history}/> */}
                    <PrivateRoute exact path="/organisation/:id/user/compability" component={Compatibility} history={history}/>
                    <PrivateRoute exact path="/organisation/:id/user/compability/:individual/:selectedTeam/:role" component={Compatibility} history={history}/>



                    <PrivateRoute exact path="/organisation/:id/user/role-fitment" component={RoleFitment} history={history}/>
                    <PrivateRoute exact path="/organisation/:id/user/role-fitment/:assessment/:holder/:fitment" component={RoleFitment} history={history}/>



                    <PrivateRoute exact path="/organisation/:id/user/competency-indicator" component={Competence} history={history}/>
                    <PrivateRoute exact path="/organisation/:id/user/learning-and-development" component={LAndD} history={history}/>
                    <PrivateRoute exact path="/organisation/:id/user/attrition-predictor" component={AttritionPredictor} history={history}/>
                    <PrivateRoute exact path="/organisation/:id/user/hiring-probability" component={HiringProbability} history={history}/>
                    <PrivateRoute exact path="/organisation/:id/my-teams" component={VirtualTeams} history={history}/>
                    {/* End */}

                    {/* Analysis swot category */}
                    <PrivateRoute exact path="/organisation/:id/user/swot/:swotid" component={SWOT} history={history} />
                    {/* swot parameters */}
                    <PrivateRoute exact path="/organisation/:id/user/swot/:swotid/swot-detail/:parameters" component={SwotParameters} history={history} />
                    {/* end */}
                    {/* End */}

                    {/* Focus Areas category */}
                    <PrivateRoute exact path="/organisation/:id/user/focus-area/orientations/:orientcategory" component={FocusArea} history={history}/>
                    {/* Focus Area All */}
                    <PrivateRoute exact path="/organisation/:id/user/focus-area/all/:allcategory" component={FocusArea} history={history}/>
                    {/* End */}
                    {/* End */}

                    {/* Review Questions category */}
                    <PrivateRoute exact path="/organisation/:id/user/review-questions/review-questions-details/:reviewid" component={ReviewQuestion} history={history}/>
                    {/* End */}

                    {/* Collaboration sub cat */}
                    <PrivateRoute exact path="/organisation/:id/user/collaboration/detailed/:colabo" component={Collaboration} history={history}/>
                    <PrivateRoute exact path="/organisation/:id/user/collaboration/detailed/:colabo/:teamId" component={Collaboration} history={history}/>
                    {/* Collaboration sub cat end */}

                    {/* L&D Orientation */}
                    <PrivateRoute exact path="/organisation/:id/user/learning-and-development/orientations/:lnd/:lndcat" component={LDOrientation} history={history}/>
                    {/* End L&D Orientation */}

                    {/* Virtual Teams Subs */}
                    <PrivateRoute exact path="/organisation/:id/my-teams/manage-virtual-teams" component={ManageTeams} history={history}/>
                    <PrivateRoute exact path="/organisation/:id/my-teams/virtual-teams/manage-members" component={TeamMembers} history={history}/>
                    <PrivateRoute exact path="/organisation/:id/my-teams/virtual-teams/manage-members/:teamid" component={TeamMembers} history={history}/>
                    <PrivateRoute exact path="/organisation/:id/my-teams/virtual-teams/manage-share" component={ShareTeam} history={history}/>
                    <PrivateRoute exact path="/organisation/:id/my-teams/virtual-teams/manage-share/:teamid" component={ShareTeam} history={history}/>
                    {/* End of Virtual Teams Subs */}
                    <Route exact path="/set-password/:hashOne/:hashTwo/" component={SetPassword} />

                    <Route exact path="/login/forgot-password" component={ForgotPassword} />



                    <Route exact path="/login" component={LoginPage} />
                </div>
            </Router>
        );
    }
}

function mapStateToProps(state) {
    const { alert } = state;
    return {
        alert,
        state
    };
}

const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App }; 


// WEBPACK FOOTER //
// ./src/App/App.jsx